export const defaultLocale = 'en-US';
